import { Grid } from "@mui/material";
import { ContentForm } from "../../../../components/viewCadastro/formCad";
import { isEmpty } from "../../../../services/utils";
import { ViewClienteCadModal } from "../../../cliente/view/cliente.cad";
import { ViewSelecionarCliente } from "../../../cliente/view/cliente.select";
import  SelecionarFuncionario  from "../../../funcionario/view/funcionario.select";
import MeiopgSelect from "../../../meioPag/view/meiopg.select";
import { Movimentacao } from "../../mov.model";
import DescontoModal from "./descontoModal";
import { ViewSelecionarFornecedor } from "../../../fornecedor/view/forn.select";
import { FornecedorActions } from "../../../fornecedor/forn.model";
import { ClienteActions } from "../../../cliente/cliente.model";
import { CanalDistMov, TipoMovDesc } from "../../../../data.types";
import { FuncionarioActions } from "../../../funcionario/funcionario.model";
import SelecionarCanalDistribuicao from "../../../canalDist/view/canalDist.select"

interface FormMovimentacaoProps {
    clienteActions: ClienteActions;
    fornecedorActions: FornecedorActions;
    funcionarioActions: FuncionarioActions;
    mutatorLocal: (value: any, field: string) => void;
    showDescontoModal: boolean;
    setShowDescontoModal: (value: boolean) => void;
    mov: Movimentacao;
    fieldShow?: string[];
    fieldDisabled?: string[];
}
export const FormMovimentacao = (props:FormMovimentacaoProps) => {
    const { clienteActions, mutatorLocal, showDescontoModal, setShowDescontoModal, mov,fieldShow,fieldDisabled, fornecedorActions,funcionarioActions } = props;

    const calcTotalPagar = () => {
        if(isEmpty(mov.fechamento)) return 0;
        return mov.fechamento.total - mov.fechamento.pagamentos.map(mp => mp.valor).reduce((a, b) => a + b, 0);
    }

    const getLabelPessoa = () => {
        switch (mov.tipo_mov.descricao) {
            case TipoMovDesc.VENDA:
                return "Cliente";
            case TipoMovDesc.COMPRA:
                return "Fornecedor";
            case TipoMovDesc.PEDIDO:
                return "Cliente"
            case TipoMovDesc.AVARIA:
                return "Funcionário"
            default:
                return "";
        }
    }

    const getActionShow = () => {
        switch (mov.tipo_mov.descricao) {
            case TipoMovDesc.VENDA:
                return clienteActions.setShowSelectModal(true);
            case TipoMovDesc.COMPRA:
                return fornecedorActions.setShowSelectModal(true);
            case TipoMovDesc.PEDIDO:
                return clienteActions.setShowSelectModal(true);
            case TipoMovDesc.AVARIA:
                return funcionarioActions.setShowSelectModal(true);
            default:
                return "";
        }
    }
    return (
        <Grid container spacing={2}>
            <ContentForm fieldName={"codigo"} type="text" label={mov.tipo_mov.descricao === "COMPRA"?"N° Nota":"Código"} colunsXS={12} colunsSM={6} colunsMD={4} hidden={fieldShow&&fieldShow.findIndex(value=>value==="codigo")===-1} disabled={fieldDisabled&&fieldDisabled.findIndex(value=>value==="codigo")!==-1} />
            <ContentForm 
                fieldName={"pessoa.nome"} 
                type="select-dialog" 
                label={getLabelPessoa()}
                colunsXS={12} colunsSM={6} colunsMD={8} 
                hidden={fieldShow&&fieldShow.findIndex(value=>value==="pessoa.nome")===-1}
                handleOnClickShow={() => getActionShow()}
            />
            <ContentForm fieldName={"created_at"} type="data" label="Data" colunsXS={6} colunsSM={6} colunsMD={6} hidden={fieldShow&&fieldShow.findIndex(value=>value==="created_at")===-1} />
            <ContentForm fieldName={"situacao"} type="text" label="Situação" colunsXS={6} colunsSM={6} colunsMD={6} disabled hidden={fieldShow&&fieldShow.findIndex(value=>value==="situacao")===-1} />
            <ContentForm fieldName={"fechamento.subtotal"} type="currency" label="Total Itens" colunsXS={4} colunsSM={4}  colunsMD={4} disabled={true} hidden={fieldShow&&fieldShow.findIndex(value=>value==="fechamento.subtotal")===-1} />
            <ContentForm fieldName={"fechamento.descontos"} type="currency" label="Descontos" colunsXS={4} colunsSM={4} colunsMD={4} disabled={true} hidden={fieldShow&&fieldShow.findIndex(value=>value==="fechamento.descontos")===-1} />
            <ContentForm fieldName={"fechamento.total"} type="currency" label="Total Notal" colunsXS={4} colunsSM={4} colunsMD={4} disabled={true} hidden={fieldShow&&fieldShow.findIndex(value=>value==="fechamento.total")===-1} />
            <ContentForm fieldName={"obs"} type="text" label="Observações" colunsXS={12} colunsSM={12} colunsMD={12} hidden={fieldShow&&fieldShow.findIndex(value=>value==="obs")===-1} />
            <ContentForm fieldName={"fechamento.pagamentos"} type="text" label="Meios de pagamentos" colunsXS={12} colunsSM={12} colunsMD={12} hidden />
            <ContentForm fieldName={"data_situacao"} type="text" label="Meios de pagamentos" colunsXS={12} colunsSM={12} colunsMD={12} hidden />
            
            

            <ViewClienteCadModal
                handleCloseView={(row) => {
                    clienteActions.setShowCadModal(false)
                    if(row !== undefined){
                        mutatorLocal(row, "pessoa")
                    }
                }}
            />

            <ViewSelecionarCliente
                handleConfirmar={(cliente) => mutatorLocal(cliente, "pessoa")}
            />

            <ViewSelecionarFornecedor
                handleConfirmar={(forn) => mutatorLocal(forn, "pessoa")}
            />  

            <SelecionarFuncionario 
                handleConfirmar={(func) => mutatorLocal(func, "pessoa")}
            />          

            <SelecionarCanalDistribuicao
                filtroData={mov.created_at}
                handleConfirmar={(canal) => {
                    if(mov.tipo_mov.descricao === TipoMovDesc.AVARIA){
                        mutatorLocal(canal.funcionario, "pessoa")
                    } else {
                        let canalDist:CanalDistMov = {
                            _id:canal._id,
                            data:canal.data,
                            funcionario:canal.funcionario
                        }
                        mutatorLocal(canalDist, "canal_dist")
                    }
                }}
            />

            <MeiopgSelect
                confirme={(value) => mutatorLocal(value, "meioPagAdd")}
                valor={calcTotalPagar()}
            />
            <DescontoModal
                title="Informar desconto"
                confirmar={(desconto) => {
                    mutatorLocal(desconto, "desconto")
                    setShowDescontoModal(false)
                }}
                handleClose={() => setShowDescontoModal(false)}
                show={showDescontoModal}
            />
        </Grid>
    )
}